import { AppThunk } from '.';
import { tosApi } from '../../services/tosApi';
import { removeToken } from './authStore';
import { logout } from './userStore';

/**
 * Fully clears the authenticated session.
 *
 * Drops the auth tokens, resets the user slice, AND wipes the RTK Query cache.
 * The cache reset is the important part: query results such as
 * GET /core/auth/user/sections are keyed by a constant arg, so without it the
 * next account that logs in (without a full page reload) keeps seeing the
 * previous account's cached sections in the sidebar. Use this everywhere a
 * session is torn down so the cache never outlives the account.
 */
export const clearSession = (): AppThunk => (dispatch) => {
  dispatch(removeToken());
  dispatch(logout());
  dispatch(tosApi.util.resetApiState());
};
